export default {"src":"/_next/static/media/covid_icon.5a4229a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};